import promotionCodeSymbols from "../symbols/promotionCodes";

export interface IReferralCode {
    Id: string
    Code:string
    Created:Date
    Expires:Date
    StartDate:Date
    MinimumSpend:number | null
    Amount:number | null
    Percentage:number | null
    PromoCodeType:string
    DiscountType:string
    UseType:string
    Active:boolean
    FirstName : string
    LastName : string
    Email : string
    PhoneNumber : string
}

type GetReferralCodesDataResponseModel = {
  GroupName: string;
  ReferralCodes: IReferralCode[];
};

type GetReferralCodesResponseModel = {
  Count: number;
  Data: GetReferralCodesDataResponseModel[];
};

export interface IReferralCodeState {
  data: GetReferralCodesResponseModel;
  loading: boolean;
  error: boolean;
}

const initialState: IReferralCodeState = {
  data: {
    Count: 0,
    Data: [],
  },
  loading: false,
  error: false,
};

export default function ReferralCodesSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case promotionCodeSymbols.GET_REFERRAL_CODES:
      return { ...state, loading: true, error: false };
    case promotionCodeSymbols.GET_REFERRAL_CODES_SUCCESS:
      if (!state.data.Data?.length) {
        return {
          ...state,
          data: action.payload.Result,
          loading: false,
          error: false,
        };
      }

      return {
        ...state,
        data: {
          Count: action.payload.Result.Count,
          Data: [...state.data.Data, ...action.payload.Result.Data],
        },
        loading: false,
        error: false,
      };
    case promotionCodeSymbols.GET_REFERRAL_CODES_FAILURE:
      return {
        ...state,
        data: {
          Count: 0,
          Data: [],
        },
        loading: false,
        error: true
      };
    case promotionCodeSymbols.CLEAR_REFERRAL_CODES:
      return {
        ...state,
        data: {
          Count: 0,
          Data: [],
        },
        loading: false,
        error: false
      };
    default:
      return state;
  }
}
